module.exports = __webpack_public_path__ + "static/media/micpic.00ccbf1d.png";